import { useEffect, useState } from "react";
import { Spin, Button } from "antd";
import { userSubscriptionInfo } from "../api/profile";
import { getUserRole } from "./service";
import { useNavigate } from "react-router-dom";

const PlanAlert = () => {
  const [activePlan, setActivePlan] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  const userRole = getUserRole();

  const fetchData = async () => {
    setFetching(true);
    try {
      const subscriptionRes = await userSubscriptionInfo();
      setActivePlan(subscriptionRes?.activePlan);
    } catch (error) {
      console.error("Error fetching subscription info:", error);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 1000); 
  
    return () => clearTimeout(timer);
  }, []);

  if (
    !visible ||
    (activePlan?.name && !activePlan.name.toLowerCase().includes("free")) ||
    ["superadmin", "user"].includes(userRole)
  ) {
    return null;
  }
  

  return (
    <div className="plan-alert-banner p-2 rounded-lg border border-yellow-300 bg-yellow-50 flex justify-between items-center text-sm">
      <div>
        <strong className="text-yellow-700">Upgrade Your Plan</strong>
        <p className="text-yellow-600 mt-1">
          You are currently on the Free Plan.{" "}
          <span className="underline text-blue-600 cursor-pointer" onClick={() => navigate('/pricing')}>
            Upgrade to access more features!
          </span>
        </p>
      </div>
      <div className="flex gap-4">
        <Button type="primary" size="small" onClick={() => navigate('/pricing')}>
          Upgrade Now
        </Button>
        <Button type="text" size="small" className="ml-4" onClick={() => setVisible(false)}>
          Dismiss
        </Button>
      </div>
    </div>
  );
};

export default PlanAlert;
